import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormSelect } from '../../../../components/form/FormSelect';
import { creditFormInitialValues } from '../form';
import { CommonContactFields } from '../components/CommonContactFields';

export const IssueForm = ({ control, errors, register, selectMenus, validations }) => {
  const { t } = useTranslation();
  const initialValues = creditFormInitialValues.issue;

  return (
    <div className='flex flex-col gap-4'>
      <FormSelect
        label={t('BIZ_TITLE')}
        required
        name='reductionCertSeq'
        control={control}
        menus={selectMenus}
        error={errors.reductionCertSeq}
        rules={validations?.reductionCertSeq}
      />
      <CommonContactFields
        register={register}
        errors={errors}
        initialValues={initialValues}
        layout='grid'
        validations={validations}
      />
    </div>
  );
};

